import { useEffect } from 'react';
import { IGiftCardCommonData } from '../models/common-models';

interface IRecaptchaProp {
  onSubmit: (token: string, variables: IGiftCardCommonData[] | undefined) => void;
  siteKey: string | undefined;
  action: string;
}

const useReCaptcha = (props: IRecaptchaProp) => {
  const { onSubmit, siteKey, action } = props;

  const getToken = (variables?: IGiftCardCommonData[]) => {
    const grecaptcha = window?.grecaptcha?.enterprise;
    grecaptcha?.ready(() => {
      grecaptcha.execute(`${siteKey}`, { action }).then((token: string) => {
        onSubmit(token, variables);
      });
    });
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
    document.body.appendChild(script);
  }, []);

  return { getToken };
};

export default useReCaptcha;
